import { create } from 'zustand';

type Theme = 'dark' | 'light';

const STORAGE_KEY = 'quarry.theme';

function initialTheme(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
  } catch {
    /* private mode / blocked storage - fall through to the default */
  }
  // Suremix brand (docs/26): light is the default; dark is one tap away.
  return 'light';
}

const NAV_KEY = 'suremix.navCollapsed';

function initialCollapsed(): boolean {
  try {
    return localStorage.getItem(NAV_KEY) === '1';
  } catch {
    return false;
  }
}

interface UiState {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggleTheme: () => void;
  /** The desktop menu as an icon rail; remembered on this device. */
  navCollapsed: boolean;
  setNavCollapsed: (v: boolean) => void;
  toggleNav: () => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  theme: initialTheme(),
  setTheme: (theme) => {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* ignore */
    }
    set({ theme });
  },
  toggleTheme: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
  navCollapsed: initialCollapsed(),
  setNavCollapsed: (navCollapsed) => {
    try {
      localStorage.setItem(NAV_KEY, navCollapsed ? '1' : '0');
    } catch {
      /* ignore */
    }
    set({ navCollapsed });
  },
  toggleNav: () => get().setNavCollapsed(!get().navCollapsed),
}));
